__turbopack_context__.v({
  "calendarHeader": "a2HdsW_calendarHeader",
  "calendarHeaderControl": "a2HdsW_calendarHeaderControl",
  "calendarHeaderControlIcon": "a2HdsW_calendarHeaderControlIcon",
  "calendarHeaderLevel": "a2HdsW_calendarHeaderLevel",
  "day": "a2HdsW_day",
  "levelsGroup": "a2HdsW_levelsGroup",
  "month": "a2HdsW_month",
  "monthCell": "a2HdsW_monthCell",
  "monthRow": "a2HdsW_monthRow",
  "monthsList": "a2HdsW_monthsList",
  "monthsListCell": "a2HdsW_monthsListCell",
  "monthsListControl": "a2HdsW_monthsListControl",
  "monthsListRow": "a2HdsW_monthsListRow",
  "weekday": "a2HdsW_weekday",
  "weekdaysRow": "a2HdsW_weekdaysRow",
  "yearsList": "a2HdsW_yearsList",
  "yearsListCell": "a2HdsW_yearsListCell",
  "yearsListControl": "a2HdsW_yearsListControl",
  "yearsListRow": "a2HdsW_yearsListRow",
});
